var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0068FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29289 17.2929L4.75 12.75C4.33579 12.3358 4.33579 11.6642 4.75 11.25C5.16421 10.8358 5.83579 10.8358 6.25 11.25L9.71716 14.7172C9.87337 14.8734 10.1266 14.8734 10.2828 14.7172L17.75 7.25C18.1642 6.83579 18.8358 6.83579 19.25 7.25C19.6642 7.66421 19.6642 8.33579 19.25 8.75L10.7071 17.2929C10.3166 17.6834 9.68342 17.6834 9.29289 17.2929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.6db7fa346c16675a32d270e448ec2ce9.svg";
export { ForwardRef as ReactComponent };